/* eslint-disable no-shadow */

import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";
import {
	GetSensors,
	GetSensorsError,
	GetSensorsSuccess,
} from "@/stores/actions/Sensors";

const state = {
	error:  {},
	status: FetchStatus.Init,
	data:   [],
};

const actions = {
	[GetSensors]: ({ commit }, monitoringElementId) =>
	{
		commit(GetSensors);
		http.get(`/Sensors/${monitoringElementId}`)
			.then((resp) =>
			{
				commit(GetSensorsSuccess, resp);
			})
			.catch((error) =>
			{
				commit(GetSensorsError, error);
			});
	},
};

const mutations = {
	[GetSensorsError]: (state, error) =>
	{
		state.error = error.response;
		state.status = FetchStatus.Error;
	},
	[GetSensors]: (state) =>
	{
		state.data = [];
		state.status = FetchStatus.Loading;
	},
	[GetSensorsSuccess]: (state, resp) =>
	{
		state.data = resp.data;
		state.status = FetchStatus.Loaded;
	},
};

export default {
	state,
	actions,
	mutations,
};
